const validationRules = () => ({
	email: {
		email: true
	}
})

export default validationRules